import { useFeatureFlagsStore } from '@/stores/featureFlags'

export default defineNuxtPlugin(async (nuxtApp) => {
  const featureFlagsStore = useFeatureFlagsStore()

  if (!featureFlagsStore.isFetched) {
    await featureFlagsStore.fetchFeatureFlags()
  }

  const isEnabled = ({ name = '' }) => {
    if (!featureFlagsStore.flags || !featureFlagsStore.flags.toggles) {
      return false
    }

    return featureFlagsStore.flags.toggles.some((f) => f.name === name && f.enabled)
  }

  nuxtApp.provide('flags', { isEnabled })
})
